var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":"","loading":_vm.isLoading('get:operadoras'),"height":400}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }